export const GAME_MODES = {
  STORY: 'STORY',
  STAGE_TEST: 'STAGE_TEST',
};

export const CUTSCENES = {
  intro: {
    spineid: 'intro',
    animation: 'animation',
    copyPrefix: 'cutscene_intro_',
  },
  outro: {
    spineid: 'outro',
    animation: 'animation',
    copyPrefix: 'cutscene_outro_',
  },
  interstitial: {
    spineid: 'interstitial',
    animation: 'animation',
    copyPrefix: 'cutscene_interstitial_',
  },
};

export const COLLISION_GROUPS = {
  HERO_BODY: 1,
  HERO_ATTACK: 2,
  ENEMY_BODY: 3,
  ENEMY_ATTACK: 4,
  PICKUP: 5,
  DESTRUCTIBLE: 6,
  COIN: 7,
  PROJECTILE_ENEMY: 8,
  PROJECTILE_HERO: 9,
};
export const COLLISION_COLOURS = {
  BODY: 0x00ffff,
  ATTACK: 0xffff00,
  PICKUP: 0x00ff00,
  COIN: 0xffa500,
  SOLID: 0xff0000,
  PROJECTILE: 0x0000ff,
};

export const SUPPORTED_LOCALES = [
  'ar',
  'bg',
  'cz',
  'da',
  'de',
  'en',
  'es',
  'es-419',
  'fr',
  'hu',
  'it',
  'nl',
  'no',
  'pl',
  'pt',
  'pt-br',
  'ro',
  'ru',
  'tr',
];
